module.exports = __webpack_public_path__ + "5b90cfda59a238352643e3d55e2d96e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/logo-bnb.png
// module id = 69
// module chunks = 0